<template>
  <div id="detalleCajaChica" :data-ready="printReady">
    <v-toolbar>
      <img src="@/assets/logo_javer.png" height="60" width="auto">
      <v-spacer></v-spacer>
      <v-toolbar-title>Detalle de fondo fijo de caja</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex xs6>
            <v-container fluid>
              <h3>GENERAL</h3><br/>
              <v-radio-group v-model="detalle.area" :mandatory="false">
                <div slot="label"><strong>Área</strong></div>
                <v-radio label="Oficinas administrativas" color="primary" value="oficinas_administrativas"></v-radio>
                <v-radio label="Oficinas comerciales" color="primary" value="oficinas_comerciales"></v-radio>
              </v-radio-group>
              <br/>
              <h3>RESPONSABLE</h3><br/>
              <v-text-field v-model="detalle.nombre" label="Nombre"></v-text-field>
              <v-text-field v-model="detalle.puesto" label="Puesto"></v-text-field>
              <v-text-field v-model="detalle.departamento" label="Departamento"></v-text-field>
              <v-text-field v-model="detalle.oficina" label="Oficina"></v-text-field>
              <v-text-field v-model="detalle.centro" label="Centro de costos"></v-text-field>
              <br/>
              <h3>FIRMAS</h3><br/>
              <v-list three-line>
                <template v-for="(item, i) in detalle.firmas">
                  <v-list-tile class="pb-2 pt-2">
                    <v-list-tile-content>
                      <v-list-tile-title v-html="item.rol"></v-list-tile-title>
                      <v-list-tile-title v-html="item.nombre"></v-list-tile-title>
                      <v-list-tile-sub-title v-html="item.estado"></v-list-tile-sub-title>
                      <v-list-tile-sub-title v-show="item.estado !== 'En aprobación'" v-html="item.fecha_actualizacion"></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider v-show="(i + 1) < detalle.firmas.length"></v-divider>
                </template>
              </v-list>
            </v-container>
          </v-flex>
          <v-flex xs6>
            <v-container fluid>
              <h3>FONDO FIJO</h3><br/>
              <v-text-field v-model.lazy="detalle.importe" label="Importe" prefix="$" suffix="MXN"></v-text-field>
              <v-text-field v-model="detalle.letra" label="Importe con letra"></v-text-field>
              <v-text-field v-model="detalle.detalle" label="Detalle"></v-text-field>
              <v-text-field v-model="detalle.empresa" label="Empresa"></v-text-field>
              <v-text-field v-model="detalle.observaciones" label="Observaciones"></v-text-field>
              <br/>
            </v-container>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </div>
</template>

<script>
import axios from 'axios'
import services from '@/config/services'
import printReady from '@/utils/printReady'

export default {
  name: 'detalleCajaChica',
  mixins: [printReady],
  data: () => ({
    loading: false,
    detalle: {
      estado: '',
      area: null,
      nombre: '',
      puesto: '',
      departamento: '',
      oficina: '',
      centro: '',
      importe: '',
      letra: '',
      detalle: '',
      empresa: '',
      observaciones: '',
      firmas: [],
      pagare: { nombre: '', data: null },
      responsiva: { nombre: '', data: null },
      incremento: {
        id: '',
        importe: '',
        letra: '',
        observaciones: '',
        pagare: { nombre: '', data: null },
        responsiva: { nombre: '', data: null },
        firmas: []
      }
    },
    color: {
      pagare: '',
      responsiva: ''
    }
  }),
  mounted() {
    var token = this.getQueryVariable('token')
    var id = this.getQueryVariable('id')
    this.$session.start()
    this.$session.set('jwt', token)
    this.detailRequest(id)
  },
  methods: {
    ws(method, name, data) {
      if (method === 'get') {
        if (this.$session.exists()) {
          let jwt = this.$session.get('jwt')
          let headers = {
            'Authorization': 'Bearer ' + jwt
          }
          let params = ''
          for (let k in data) {
            params += k + '=' + data[k] + '&'
          }
          params = (params !== '') ? '?' + params : ''
          return axios.get(services.routes[name] + params, { headers })
            .then(response => {
              let res = response.data
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje }
              } else {
                return { ok: false, message: res.mensaje }
              }
            })
            .catch(error => {
              console.log(error)
              error.response.status === 403 && this.$router.push('/403')
              return { ok: false, message: 'El servicio no se encuentra disponible en estos momentos' }
            })
        } else {
          this.$router.push('/login')
        }
      }
      else {
        if (this.$session.exists()) {
          let jwt = this.$session.get('jwt')
          let headers = {
            'Authorization': 'Bearer ' + jwt
          }
          return axios.post(services.routes[name], data, { headers })
            .then(response => {
              let res = response.data
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje }
              } else {
                return { ok: false, message: res.mensaje }
              }
            })
            .catch(error => {
              console.log(error)
              error.response.status === 403 && this.$router.push('/403')
              return { ok: false, message: 'El servicio no se encuentra disponible en estos momentos' }
            })
        } else {
          this.$router.push('/login')
        }
      }
    },
    getQueryVariable(variable) {
      let query = window.location.search.substring(1)
      let vars = query.split("&")
      for (var i = 0; i < vars.length; i++) {
        let pair = vars[i].split("=")
        if (pair[0] == variable) {
          return pair[1]
        }
      }
      return(false)
    },
    prepareDetailForm(data) {
      this.detalle.nombre = data.detalle_usuario.nombre + ' ' + data.detalle_usuario.apellido_paterno + ' ' +
                            data.detalle_usuario.apellido_materno
      this.detalle.nombre = this.detalle.nombre.trim();
      this.detalle.puesto = data.detalle_usuario.puesto
      this.detalle.departamento = data.detalle_usuario.departamento
      this.detalle.oficina = data.detalle_usuario.ubicacion
      this.detalle.estado = data.solicitud.estado
      this.detalle.area = data.solicitud.area
      this.detalle.centro = data.solicitud.centro
      this.detalle.importe = data.solicitud.importe.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      this.detalle.letra = data.solicitud.letra
      this.detalle.detalle = data.solicitud.detalle
      this.detalle.empresa = data.solicitud.empresa
      this.detalle.observaciones = data.solicitud.observaciones
      this.detalle.pagare.nombre = data.solicitud.pagare.nombre
      this.detalle.pagare.data = data.solicitud.pagare.data
      this.detalle.responsiva.nombre = data.solicitud.responsiva.nombre
      this.detalle.responsiva.data = data.solicitud.responsiva.data
      this.detalle.firmas = data.firmas
      this.dialogDetReq = true
    },
    detailRequest(id) {
      this.loading = true
      this.ws('get', 'detalleSolicitudCajaChica', { id })
        .then(res => {
          if (res.ok) {
            this.prepareDetailForm(res.data)
            this.markPrintReady()
          }
          else {
            this.error = true
            this.msgError = res.message
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
